module.exports = __webpack_public_path__ + "static/media/Screenshot_1.fc6dee8b.png";